<template>
	<div class="table-responsive">
        <table class="table table-striped table-condensed table-border">
			<thead class="thead-style" v-bind:class="{ 'dark-green': dark }">
				<tr>
					<th scope="col"></th>
                    <th scope="col"></th>
					<th scope="col">Jan</th>
					<th scope="col">Feb</th>
					<th scope="col">Mar</th>
					<th scope="col">Apr</th>
					<th scope="col">May</th>
					<th scope="col">Jun</th>
					<th scope="col">Jul</th>
					<th scope="col">Aug</th>
					<th scope="col">Sep</th>
					<th scope="col">Oct</th>
					<th scope="col">Nov</th>
					<th scope="col">Dec</th>
					<th scope="col">Total</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="propertyFee, key, index in getProperties">
					<td scope="row" class="test"> 
						<strong> 
							<div v-if="propertyFee.is_building">
								<a :href="'/admin/statment/' + propertyFee.propertyId"> {{ propertyFee.propertyName }}</a>
							</div>
							<div v-else>
                               {{ propertyFee.propertyName }}
							</div>
						</strong>
					</td>
                    <td></td>
					<td v-for="fee, key2 in propertyFee.fees">						
						<div v-if="key2 > 11">
							<strong> 
								<div v-if="fee == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
							</strong>
						</div>
                        <div v-else>
                            <div v-if="fee == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee) }}
                            </div>
                        </div>                       
                    </td>
                    </tr>
                <tr>
					<td scope="row">
						<strong> 
							 Total 
						</strong>
					</td>
                    <td></td>
					<td v-for="total in totalFees"> 
						<strong> 
							<div v-if="total == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(total) }}
                            </div> 
						</strong> 
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
    
import { authenticationService } from '@/_services';
    export default {
		props : ['buildingId', 'route','period','filter', 'dark'],
        data: function () {
  return {
	propertyFees : [], 
	totalFees : [],
	index : 0,
	isModalVisible: true,
	propertyId: 0,
    monthParam: 0,
    currentUser:null
  }
},
 watch: {
    value(val) {
      this.$emit('update:buildingId', val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    }
  },
  created(){
      authenticationService.currentUser.subscribe(x => this.currentUser = x);
  },
                                
                    mounted() {
                        if(this.buildingId)
                            this.fetchStatement();
                        //this.propertyHistory = JSON.parse(this.propertyAttribute)
                        
                        //console.log(this.propertyAttribute)
                        //this.propertyHistory = this.propertyAttribute
                    },

                    methods: {
                        beforeOpen (event) {
                            this.propertyId = event.params.creditortypeid;
                            this.monthParam = event.params.month + 1;
                    },
                                    showModal() {
                    this.isModalVisible = true;
                    alert(this.isModalVisible)
                    },
                    closeModal() {
                    this.isModalVisible = false;
                    },
					/*fetchStatement: function(){
							this.mute = true;
							var request = '/admin/statment/collected/get/';
							if(this.route =="home")
								request = '/home/statment/collected/get/';
							
							request = request+this.buildingId;
                            request = request + '/' + (this.period == null ? 1 : this.period);
                            window.axios.get(request).then(({data}) => {
                                    
                                this.mute = false;
                                this.propertyFees = JSON.parse(data.propertyFees);
                                this.totalFees = data.totalFees;
					});
					
                    },*/
                    
                    fetchStatement: function(){
							this.mute = true;
						var request = '/statement/income';
               // if(this.route=="home")
                 //   request = '/home/statment/get/';
               //  if(this.currentUser.role === "Owner")
                //    request = request+'/owner?id='+this.buildingId+'&userid='+ this.currentUser.id +'&period='+this.period;
                // else
                    request = request+'?id='+this.buildingId+'&period='+this.period;
              /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/
                  
                    this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                           this.mute = false;
                    // let myObjStr = JSON.stringify(data.expenseFees);
                    this.propertyFees = data.propertyFees;
                    this.totalFees = data.totalFees;

                });
							


					},
                    showModalTemp: function(propertyId, month){
                            //this.$modal.show('creditors-form', { 'creditortypeid': creditorId,  'month' : month});
                        //alert("Id " + expenseId + " month " + month);
                        //this.isModalVisible = true;
                        
                    },
                                        show () {
   // this.$modal.show('creditors-form');
  },
  hide () {
   // this.$modal.hide('creditors-form');
  },

            /**
             * Prepare the component.
             */
            
            },
			
			computed : {
                yearCalculated(){
                    return new Date().getFullYear() - (this.$period.yearsBack(this.period))
                },
				getProperties() {
      
                    var propertyFees = this.propertyFees.filter((propertyFee) => {
					
												if(this.filter)
													return propertyFee.propertyName.toLowerCase().includes(this.filter.toLowerCase());
												else
													return this.propertyFees;
                        });
                    
                    return propertyFees;
                    
                    },
			total: function(){
				return this.propertyFees[0].reduce(function(total, fees){

                return total + fees[0]; 
				},0);
        },
			}

	}                // Our Javascript logic
    
    
</script>
